import * as React from "react";

import Layout from "@/layout/Layout";

import { useGroup } from "@/pages/group/GroupContext";

import { NetsuiteHardwareOrderFormSteps } from "./NetsuiteHardwareOrderFormSteps";

export const HardwareOrderFormPage: React.FC = () => {
  return (
    <Layout>
      <NetsuiteHardwareOrderFormSteps />
    </Layout>
  );
};

export const GroupHardwareOrderFormPage: React.FC = () => {
  const { group } = useGroup();

  return (
    <Layout>
      <NetsuiteHardwareOrderFormSteps groupId={group.id} />
    </Layout>
  );
};
